// extracted by mini-css-extract-plugin
module.exports = {"link":"paymentWidget_link__Y4OfY","text":"paymentWidget_text__0Wvqz","cardRow":"paymentWidget_cardRow__luMrK"};